import { createAction, props } from '@ngrx/store';

export const enum HeadersActionTypes {
  loadHeaders = '[headers] LOAD_HEADERS',
  setHeaders = '[headers] SET_HEADERS',
}

export const loadHeaders = createAction(HeadersActionTypes.loadHeaders);

export const setHeaders = createAction(
  HeadersActionTypes.setHeaders,
  props<{
    geoClientCountry: string | null;
    geoClientIp: string | null;
    is201Enabled?: boolean | null;
  }>(),
);
